import * as CoreComponents from './core/'
import * as PagesComponents from './pages/'
import * as GenericComponents from './generic/'
import * as BookingComponents from './booking/'
import * as AboutComponents from './about/'
import * as VisionMissionComponents from './vision-mission/'
import * as ProfileComponents from './profile/'
import * as StaticComponents from './club-loyalty'
import * as StaticPagesComponents from './static-page'
import * as NewsComponents from './news'
import * as VoucherComponents from './vouchers'
import * as ExclusiveToSkComponents from './exclusive-to-sk'
import * as ProcurementTabs from './procurement-tabs'
import * as CareersTabs from './careers-tabs'
import * as Performance from './performance'

export default Object.assign({},
    CoreComponents,
    PagesComponents,
    GenericComponents,
    BookingComponents,
    AboutComponents,
    ProfileComponents,
    StaticComponents,
    StaticPagesComponents,
    VisionMissionComponents,
    NewsComponents,
    VoucherComponents,
    ExclusiveToSkComponents,
    CareersTabs,
    Performance,
)



// WEBPACK FOOTER //
// ./src/components/index.js